export default function captializeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1, str.length);
}
